<template>
  <el-button class="f-btn" :class="{'f-btn-disable':this.disabled}" @click="handleClick">
    <svg-icon :icon-class="icon" v-if="icon" :style="{fontSize:iconSize}"></svg-icon>
    <slot/>
  </el-button>
</template>

<script>
export default {
  name: "index",
  props: {
    icon: {type: String}, iconSize: {
      type: Number, default() {
        return 16
      }
    },
    disabled: {
      type: Boolean, default: false
    }
  },
  methods: {
    handleClick() {
      if (this.disabled) {
        return;
      }
      this.$emit("click")
    }
  }
}
</script>

<style lang="scss" scoped>
.f-btn {

  margin-right: 0px;
  height: 32px;
  line-height: 0px;
  border-radius: 20px;
  font-size: 16px;
  padding: 0px 20px;
  font-family: PingFang HK;
  font-weight: 400;

  [data-theme="theme1"] & {
    background: rgba(4, 173, 154, .1);
    border: 1px solid #00f0e9;
    color: #00dcd6;
  }

  [data-theme*="theme2"] & {
    color: #0364ac;
    background: rgba(4, 102, 173, .1);
    border: 1px solid #076aaf;
  }

  position: relative;

  img {
    padding-right: 5px;
    height: 14px;
    position: absolute;
    top: 8px;
    left: 7px;
  }

  i {
    padding-left: 6px;
    font-style: normal;
  }


}

.f-btn:hover {
  font-family: PingFang HK;
  font-weight: 400;

  [data-theme="theme2"] & {
    background-color: #086BAF;
  }

  [data-theme="theme1"] & {
    background: #008286;
  }

  [data-theme="theme2_skyblue"] & {
    background: linear-gradient(180deg, rgba(72, 207, 255, 1) 0%, rgba(0, 105, 155, 1) 58%, rgba(0, 140, 203, 1) 100%);
    border: none;
    border-left: 1px solid;
    border-right: 1px solid;
    height: 32px;
  }

  color: rgba(255, 255, 255, 1);
}
.f-btn-disable{
  cursor:not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/FButton/index.vue